module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid1_800x804.0869bea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid1_800x804.jpg
// module id = yRIH
// module chunks = 0